<template>
  <div>
    <cms-buttons
      v-if="buttonsSetUp"
      :theme="buttonsOptions"
      :content="homepage.buttons[id]"
      :logo="watermarkLogo"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import { isEmpty } from 'lodash';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);
const globals = computed(() => mainStore.globals);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const buttonsOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: translationStore.getComponentTranslation('buttons'),
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

const buttonsSetUp = computed(() => !isEmpty(homepage.value?.buttons?.[id.value]?.content));

const watermarkLogo = computed(() => globals.value.watermark?.url || globals.value.logo.url);
</script>
